
import { css } from 'lit';
export default css`
:host {
  width: inherit;
}

.alphabet-nav__wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}

.alphabet-nav__description {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.alphabet-nav__description {
  text-align: center;
}

.alphabet-nav__description {
  font-size: 1.375rem;
}

.alphabet-nav__description {
  font-weight: 700;
}

.alphabet-nav__nav {
  display: flex;
}

.alphabet-nav__nav {
  justify-content: center;
}

.alphabet-nav__list {
  display: flex;
}

.alphabet-nav__list {
  flex-direction: row;
}

.alphabet-nav__list {
  overflow-x: scroll;
}

.alphabet-nav__link {
  display: inline-block;
}

.alphabet-nav__link {
  border-bottom-width: 2px;
}

.alphabet-nav__link {
  border-color: transparent;
}

.alphabet-nav__link {
  padding: 0.75rem;
}

.alphabet-nav__link {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.alphabet-nav__link {
  font-size: 1.375rem;
}

.alphabet-nav__link {
  text-transform: uppercase;
}

.alphabet-nav__link.active {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.alphabet-nav__link.active {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
`;